import "src/decidim/initiatives/application"
import "src/decidim/initiatives/scoped_type"
import "src/decidim/initiatives/initiative_creation_wizard"

// Images
require.context("../images", true)

// CSS
import "stylesheets/initiatives.scss"
